import { getMapLayersSessionKey } from "./getMapLayersSessionKey";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getMapLayersFromSession(projectId: string): any[] | undefined {
  const key = getMapLayersSessionKey(projectId);
  return JSON.parse(sessionStorage.getItem(key)) || undefined;
}
